<template>
  <div>
      <div class="article-container">
        <div class="main-image"  v-bind:style="{ backgroundImage: 'url(' + post.attributes.image + ')' }">
        </div>
        <h1>{{post.attributes.name}}</h1>
        <div class="article-body">
          <p>{{post.attributes.previewText}}</p>
        
        </div>
      
        <el-button class="read-more-btn" @click="goToArticle" type="default">Read More</el-button>
      </div>
      <article-preview :featured="true" :skip="1"></article-preview>
      <hr/>
      <article-preview :skip="1"></article-preview>
  </div>
</template>

<script>
import ArticlePreview from './article-preview';
export default {
  name: 'content',
  mounted:function(){
    var user = Parse.User.current();
    if(!user){
       this.$router.push('/login');
       return
    }
    if(!user.get('programs')){
       this.$router.push('/dashboard/my-details');
       return
    }
    this.getPost();
  },
  components: {ArticlePreview},
  data () {
    return {
      post:{attributes:{}},
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  methods:{
    getPost: function(){
      var _this = this;
      var postQuery = new Parse.Query('Post');
      postQuery.equalTo('status', 'PUBLISHED');
      postQuery.equalTo('featured', true);
      postQuery.descending('priority');
      postQuery.first()
        .then(function(results){

          _this.post = results;
        })
        .catch(function(err){
          alert('ERROR GETTING POST');
        });
    },
    goToArticle:function(){
      this.$router.push('/dashboard/content/article/'+this.post.id);
    }
  }
}
</script>

<style>
.article-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.article-container .main-image{
  height: 300px;
  background-size: cover;
}
.article-container h1 {
  width: 100%;
  text-align: left;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.read-more-btn{
  margin: 10px auto 30px;
}
</style>
